import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  cropBox: {
    position: 'relative',
    height: 400,
    width: 'auto',
    minWidth: '100%',
    borderRadius: 4,
    border: '1px solid #E0E0E0',
    overflow: 'hidden',
  },

  header: {
    padding: '1rem',
    width: '100%',
    height: '100%',
    maxHeight: 730,
    overflow: 'hidden',
  },

  body: {
    padding: '1rem',
    width: '100%',
    margin: '0.25rem 0',
  },

  closeBtnBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingBottom: '0.5rem',
  },

  closeBtn: {
    cursor: 'pointer',
    transition: 'all 300ms ease-in-out',

    '&:hover': {
      color: '#FF0000',
    },
  },

  footer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    gap: '0.5rem',
    marginTop: '1rem',
  },

  btn: {
    height: '2rem',

    '&:disabled': {
      height: '2rem',
    },
  },
}))

export { useStyles }
